import api from './api';

export const clientService = {
  async getClients(params = {}) {
    const response = await api.get('/clients', { params });
    return response.data;
  },
  
  async getClient(id) {
    const response = await api.get(`/clients/${id}`);
    return response.data.data;
  },
  
  async createClient(data) {
    const response = await api.post('/clients', data);
    return response.data.data;
  },
  
  async updateClient(id, data) {
    const response = await api.patch(`/clients/${id}`, data);
    return response.data.data;
  },
  
  async deleteClient(id) {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  },
  
  async archiveClient(id) {
    const response = await api.post(`/clients/${id}/archive`);
    return response.data.data;
  },
  
  async restoreClient(id) {
    const response = await api.post(`/clients/${id}/restore`);
    return response.data.data;
  },
  
  async updateScore(id, score) {
    const response = await api.patch(`/clients/${id}/score`, { score });
    return response.data.data;
  },
  
  async getInteractions(id, params = {}) {
    const response = await api.get(`/clients/${id}/interactions`, { params });
    return response.data;
  },
  
  async addInteraction(id, data) {
    const response = await api.post(`/clients/${id}/interactions`, data);
    return response.data.data;
  },
  
  async updateInteraction(id, interactionId, data) {
    const response = await api.patch(`/clients/${id}/interactions/${interactionId}`, data);
    return response.data.data;
  },
  
  async deleteInteraction(id, interactionId) {
    const response = await api.delete(`/clients/${id}/interactions/${interactionId}`);
    return response.data;
  },
  
  async addFollowUp(id, data) {
    const response = await api.post(`/clients/${id}/follow-ups`, data);
    return response.data.data;
  },
  
  async completeFollowUp(clientId, followUpId) {
    const response = await api.patch(`/clients/${clientId}/follow-ups/${followUpId}/complete`);
    return response.data.data;
  },
  
  async deleteFollowUp(clientId, followUpId) {
    const response = await api.delete(`/clients/${clientId}/follow-ups/${followUpId}`);
    return response.data;
  },
  
  async getStatuses() {
    const response = await api.get('/clients/statuses');
    return response.data.data;
  },
  
  async createStatus(data) {
    const response = await api.post('/clients/statuses', data);
    return response.data.data;
  },
  
  async updateStatus(id, data) {
    const response = await api.patch(`/clients/statuses/${id}`, data);
    return response.data.data;
  },
  
  async deleteStatus(id) {
    const response = await api.delete(`/clients/statuses/${id}`);
    return response.data;
  },
  
  async getSources() {
    const response = await api.get('/clients/sources');
    return response.data.data;
  },
  
  async createSource(data) {
    const response = await api.post('/clients/sources', data);
    return response.data.data;
  },
  
  async updateSource(id, data) {
    const response = await api.patch(`/clients/sources/${id}`, data);
    return response.data.data;
  },
  
  async deleteSource(id) {
    const response = await api.delete(`/clients/sources/${id}`);
    return response.data;
  },
  
  async addCustomField(id, data) {
    const response = await api.post(`/clients/${id}/custom-fields`, data);
    return response.data.data;
  },
  
  async updateCustomField(id, fieldId, data) {
    const response = await api.patch(`/clients/${id}/custom-fields/${fieldId}`, data);
    return response.data.data;
  },
  
  async deleteCustomField(id, fieldId) {
    const response = await api.delete(`/clients/${id}/custom-fields/${fieldId}`);
    return response.data;
  },
  
  async createClientAccount(id) {
    const response = await api.post(`/clients/${id}/account`);
    return response.data.data;
  },
  
  async syncClientProjects(id) {
    const response = await api.post(`/clients/${id}/account/sync-projects`);
    return response.data.data;
  },
  
  async uploadPhoto(id, file) {
    const formData = new FormData();
    formData.append('photo', file);
    const response = await api.post(`/clients/${id}/photo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data.data;
  },
  
  async deletePhoto(id) {
    const response = await api.delete(`/clients/${id}/photo`);
    return response.data;
  }
};
